var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_15890)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.75 6.66667C2.75 4.50355 4.50355 2.75 6.66667 2.75C8.82978 2.75 10.5833 4.50355 10.5833 6.66667C10.5833 8.82978 8.82978 10.5833 6.66667 10.5833C4.50355 10.5833 2.75 8.82978 2.75 6.66667ZM6.66667 1.25C3.67512 1.25 1.25 3.67512 1.25 6.66667C1.25 9.65821 3.67512 12.0833 6.66667 12.0833C7.89199 12.0833 9.02228 11.6765 9.92982 10.9905L13.4697 14.5303C13.7626 14.8232 14.2374 14.8232 14.5303 14.5303C14.8232 14.2374 14.8232 13.7626 14.5303 13.4697L10.9905 9.92982C11.6765 9.02228 12.0833 7.89199 12.0833 6.66667C12.0833 3.67512 9.65821 1.25 6.66667 1.25Z",
    fill: "#E6E6E6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_15890"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.c6d0d20a65db8ecd68000ada83687582.svg";
export { ForwardRef as ReactComponent };